import { IExtendedContext } from '../../../types/extendedContext';
import { EMoneySource } from '../../../../shared/ServicePickerWidget/types/reducers/user';
import { setPlacingMoneySource } from '../../../../shared/ServicePickerWidget/actions/publishTerms';
import { loadPublishTerms } from '../../../../shared/ServicePickerWidget/thunks/publishTerms/loadPublishTerms';

export const switchToSelfMoneySourceHandler = (context: IExtendedContext) => () => {
  context.store.dispatch(setPlacingMoneySource(EMoneySource.Self));
  context.store.dispatch(loadPublishTerms());
};
